import React from "react";

import LoadingOverlay from "src/containers/LoadingOverlay/LoadingOverlay";
import SendMassSignoffRequests from "./SendMassSignoffRequests";
import useWindowSize from "../../../../custom-hooks/useWindowSize/useWindowSize";

interface Props {
  // item?: TnADayDataWithBreaksRef | TnADayDataDTO;
  handleNotifyParent: () => void;
  children?: React.ReactNode;
  buttonText?: string;
  buttonVariant?: "text" | "outlined" | "contained";
  customButtonStyle?: React.CSSProperties;
  buttonTitle?: string;
  disabled?: boolean;
  handleParentClose?: () => void;
}

const NewSendMassSignoffRequestsWrapper = ({
  // item,
  handleNotifyParent,
  handleParentClose,
}: Props) => {
  const { height } = useWindowSize();

  return (
    <LoadingOverlay loading={height === 0}>
      {height !== 0 && (
        <SendMassSignoffRequests
          handleNotifyParent={handleNotifyParent}
          tableHeight={height - height / 2.5}
          handleParentClose={handleParentClose}
        />
      )}
    </LoadingOverlay>
  );
};

export default React.memo(NewSendMassSignoffRequestsWrapper);
